'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { reportWebVital } from '@/lib/analytics';

/**
 * Reports Core Web Vitals (LCP, INP, CLS, FCP, TTFB) to Plausible as
 * custom `web_vital` events. No-op in development or when Plausible
 * hasn't loaded (e.g. blocked by an extension).
 */
export default function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    reportWebVital({
      id: metric.id,
      name: metric.name,
      value: metric.value,
      rating: metric.rating as 'good' | 'needs-improvement' | 'poor' | undefined,
      label: metric.label,
    });
  });

  return null;
}
